import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useState } from "react";
// import { HiChatBubbleLeftRight } from "react-icons/hi2";
// import BotpressBot from "../Components/BotpressBot/BotpressBot";
import { GetAllFeaturedEvents } from "../redux/actions/Admin/AdminActions";
import HeroSlider from "../Components/Home/HeroSlider";
import { AdLandingPopup } from "../Components/Home/AdLanding";
import HomeGuaranteeStrip from "../Components/Home/HomeGuaranteeStrip";
import HomeCinematicHeroSection from "../Components/Home/HomeCinematicHeroSection";
import MarketplaceNewUISectionDiscover from "../Components/Home/MarketplaceNewUI/MarketplaceNewUISectionDiscover";
import MarketplaceNewUISectionOrganizerQR from "../Components/Home/MarketplaceNewUI/MarketplaceNewUISectionOrganizerQR";
import MarketplaceNewUIMerchPreview from "../Components/Home/MarketplaceNewUI/MarketplaceNewUIMerchPreview";
import MarketplaceNewUIPartnerScroller from "../Components/Home/MarketplaceNewUI/MarketplaceNewUIPartnerScroller";
import MarketplaceNewUIFooter from "../Components/Home/MarketplaceNewUI/MarketplaceNewUIFooter";
import { trustBadges } from "../Components/Home/MarketplaceNewUI/marketplaceHomeNewUIMockData";
// import "../Components/BotpressBot/BotpressBot.css";

/**
 * Marketplace landing aligned with new-ui `MarketplaceHome.tsx`.
 */
const Home = () => {
  const FeaturedEventsdata = useSelector((state) => state.Admin.featuredEvents);
  const dispatch = useDispatch();
  // const [showBot, setShowBot] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  useEffect(() => {
    if (FeaturedEventsdata?.length === 0) {
      dispatch(GetAllFeaturedEvents());
    }
  }, [FeaturedEventsdata?.length, dispatch]);

  return (
    <div className="min-h-screen bg-[#0d0d0d] overflow-x-hidden">
      <HeroSlider />
      {/* Ad visitors get the campaign as a pop-up over the hero */}
      <AdLandingPopup />
      <HomeGuaranteeStrip />
      <HomeCinematicHeroSection />

      <MarketplaceNewUISectionDiscover />
      <MarketplaceNewUISectionOrganizerQR />

      <section className="bg-[#111] py-10 border-y border-white/5">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-x-10 gap-y-4">
            {trustBadges.map((badge) => (
              <div key={badge.text} className="flex items-center gap-2 text-sm">
                <span className="text-[#00C853]">{badge.icon}</span>
                <span className="text-white/90">
                  <span className="font-black">{badge.bold}</span>
                  <span className="text-white/50 ml-1">{badge.text}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <MarketplaceNewUIMerchPreview />
      <MarketplaceNewUIPartnerScroller />
      <MarketplaceNewUIFooter />

      {/*
      <button
        type="button"
        className="instapass-ai-floating-btn"
        onClick={() => setShowBot(true)}
        aria-label="Open INSTAPASS AI"
      >
        <HiChatBubbleLeftRight className="instapass-ai-floating-icon" />
        <span className="instapass-ai-tooltip">TALK TO BOT</span>
      </button>

      {showBot ? (
        <>
          <div className="instapass-ai-sidebar-overlay" onClick={() => setShowBot(false)} role="presentation" />
          <div className="instapass-ai-sidebar" onClick={(e) => e.stopPropagation()}>
            <BotpressBot onClose={() => setShowBot(false)} />
          </div>
        </>
      ) : null}
      */}
    </div>
  );
};

export default Home;
